var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m124.007812 186.214844h30v-26h86.992188v191.785156h-24.746094v30h79.492188v-30h-24.746094v-191.785156h86.992188v26h30v-56h-263.984376zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m129 35.75h41.976562v30h-41.976562zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m199.675781 35.75h41.976563v30h-41.976563zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m270.347656 35.75h41.980469v30h-41.980469zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m341.023438 35.75h41.976562v30h-41.976562zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m129 446.25h41.976562v30h-41.976562zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m199.675781 446.25h41.976563v30h-41.976563zm0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m270.347656 446.25h41.980469v30h-41.980469zm0 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m341.023438 446.25h41.976562v30h-41.976562zm0 0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m446.25 129h30v41.976562h-30zm0 0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m446.25 199.675781h30v41.976563h-30zm0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m446.25 270.347656h30v41.976563h-30zm0 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m446.25 341.023438h30v41.976562h-30zm0 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m35.75 129h30v41.976562h-30zm0 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m35.75 199.675781h30v41.976563h-30zm0 0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m35.75 270.347656h30v41.976563h-30zm0 0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m35.75 341.023438h30v41.976562h-30zm0 0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m0 101.5h101.5v-101.5h-101.5zm30-71.5h41.5v41.5h-41.5zm0 0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m410.5 0v101.5h101.5v-101.5zm71.5 71.5h-41.5v-41.5h41.5zm0 0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m0 512h101.5v-101.5h-101.5zm30-71.5h41.5v41.5h-41.5zm0 0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m410.5 512h101.5v-101.5h-101.5zm30-71.5h41.5v41.5h-41.5zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditor);
export default __webpack_public_path__ + "static/media/editor.41e8c5d676fcc82a7eca9f5096698638.svg";
export { ForwardRef as ReactComponent };